'use client';

import { useEffect, useState } from 'react';
import { getPersonCategories } from '@/lib/actions/person-categories';
import { CategoryList } from '@/components/admin/people/CategoryList';

export default function AdminPersonCategoriesPage() {
  const [categories, setCategories] = useState<Awaited<ReturnType<typeof getPersonCategories>>>([]);

  useEffect(() => {
    getPersonCategories().then(setCategories);
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-navy">Person Categories</h1>
      </div>

      <CategoryList categories={categories} />
    </div>
  );
}
